import subpageHeader from '@/components/app/header/subpage-header/subpage-header.vue'
import createUpdateCompetitionContent from '@/components/pages/page-templates/create-update-competition/create-update-competition-content/create-update-competition-content.vue'
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep, find } from 'lodash'
import router from '@/router'

export default {
  components: {
    subpageHeader,
    createUpdateCompetitionContent
  },
  data() {
    return {
      owner: {},
      competition: null,
      users: []
    }
  },
  computed: {
    ...mapGetters('user', ['transformedUsersToPrivileges']),
    core: function () {
      const data = this.competition.competition.core
      data.mechanic = this.competition.competition.mechanic.name
      return data
    }
  },
  methods: {
    ...mapActions('competition', ['getOneCompetition', 'updateCompetition']),
    ...mapActions('user', ['getUser', 'getUsers']),
    editCompetition: async function (data) {
      try {
        await this.updateCompetition({ id: this.competitionId, data })
      } catch (e) {
        this.$notify({
          text: 'Error while updating competition',
          type: 'error'
        })
      }
    }
  },
  async created() {
    await this.getUsers({
      sort_by: 'name',
      status: 'enabled'
    })
    const users = cloneDeep(this.transformedUsersToPrivileges)
    this.competitionId = router.currentRoute.query.id
    this.competition = await this.getOneCompetition({ id: this.competitionId })
    this.competition.privileges.forEach((privilege) => {
      const user = find(users, { user_id: privilege.user_id })
      if (user) {
        user.role = privilege.role
      }
    })
    this.users = users
    this.owner = await this.getUser({ id: this.competition.competition.owner })
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/page-templates/create-update-competition/edit-competition/edit-competition.js